import { FC, useContext, useEffect, useState } from "react";
import { Button, Checkbox, CustomLink, Input, Layout, Result, Select } from "../../components";
import logo from "../../assets/logo.svg";
import $api from "../../http";
import config from "../../config";
import { Response, Service } from "../../types";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import { observer } from "mobx-react";

const EditService: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [services, setServices] = useState<Service[]>();
  const [selectedService, setSelectedService] = useState<string>();

  const [name, setName] = useState<string>("");
  const [price, setPrice] = useState<number>(0);
  const [sale, setSale] = useState<boolean>(false);
  const [result, setResult] = useState<Response>({ status: "error", message: "" });

  useEffect(() => {
    $api.get(`${config.API}/service/all`).then(({ data }) => setServices(data.data));
  }, []);

  useEffect(() => {
    if (selectedService) {
      $api.get(`${config.API}/service/get?id=${selectedService}`).then(({ data }) => {
        setName(data.data.name);
        setPrice(data.data.price);
        setSale(data.data.sale);
      });
    }
  }, [selectedService]);

  const sendData = () => {
    if(!name) return setResult({status: "error", message: "Укажите название услуги"});
    if(!price || !Number(price)) return setResult({status: "error", message: "Укажите цену услуги"});

    $api.put(`${config.API}/service/edit`, {id: selectedService, name, price, sale}).then(({data}) => {
      setResult({status: data.status, message: data.status === "error" ? data.message : "Успешно"});
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>
      <p>Выберите услугу</p>
      <Select defaultValue={"Выберите услугу"} onChange={({ target }) => setSelectedService(target.value)}>
        <option value={"Выберите услугу"} disabled>
          Выберите услугу
        </option>
        {services ? (
          services.map((e: Service) => (
            <option value={e._id} key={e._id}>
              {e.name} - {e.price}р - {e.sale ? "скидка" : "без скидки"}
            </option>
          ))
        ) : (
          <option>Услуги не найдены</option>
        )}
      </Select>

      {selectedService && name && (
        <>
          <Input placeholder="Название услуги" onChange={({ target }) => setName(target.value)} value={name} />
          <Input placeholder="Цена" onChange={({ target }) => Number(target.value) && setPrice(Number(target.value))} value={price} />
          <Checkbox text="Со скидкой" onChange={(e: boolean) => setSale(e)} checked={sale} />
          <Button onClick={sendData}>Сохранить</Button>
          <Result {...result} />
        </>
      )}
    </Layout>
  );
});

export default EditService;
